import { connect } from 'react-redux';
import {
    activeMemberTypeChange,
    cleanMessages,
    confirmChangesAccepted,
    confirmChangesRejected,
    createNewMember,
    deleteMemberClicked,
    managePermissionsCalled,
    managePermissionsFinished,
    resendInvitation,
    sectionSearchInputChanged,
    sectionSortClicked,
    setSectionSearch,
} from './actions';
import TeamManagement from './page';
import { getAdminModeEnabled } from '../selectors/user';
import { refreshSection } from './sagas';
import {
    getActiveUsersSection,
    getInactiveUsersSection,
    getInvitesSection,
    getAgenciesSection,
    getCurrentUserOrgId,
    getTeamManagementPage,
} from './selectors';

const mapStateToProps = state => {
    return {
        ...getTeamManagementPage(state),
        currentUserOrgId: getCurrentUserOrgId(state),
        adminModeEnabled: getAdminModeEnabled(state),
        // True only once /agencies/self has resolved at least once AND no refetch is in
        // flight. state.orgAgencies starts as null (initial), populated by init.js or the
        // saga; agenciesLegacyFetching covers the saga's after-delete / after-save refetch.
        agenciesReady: state.orgAgencies !== null && !state.teamManagement.agenciesLegacyFetching,
        sections: {
            activeUsers: getActiveUsersSection(state),
            inactiveUsers: getInactiveUsersSection(state),
            invites: getInvitesSection(state),
            agencies: getAgenciesSection(state),
        },
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDeleteMember: (...args) => {
            dispatch(deleteMemberClicked(...args));
        },
        onDeleteBtnClicked: (...args) => {
            dispatch(cleanMessages(...args));
        },
        onResendInvitation: (...args) => {
            dispatch(resendInvitation(...args));
        },
        onManagePermissions: (...args) => {
            dispatch(cleanMessages());
            dispatch(managePermissionsCalled(...args));
        },
        onCreateNewMember: (...args) => {
            dispatch(cleanMessages());
            dispatch(createNewMember(...args));
        },
        onManagePermissionsFinished: (...args) => {
            dispatch(managePermissionsFinished(...args));
        },
        onActiveMemberTypeChange: activeMemberType => {
            dispatch(cleanMessages());
            dispatch(activeMemberTypeChange(activeMemberType));
        },
        onConfirmChangesAccepted: () => dispatch(confirmChangesAccepted()),
        onConfirmChangesRejected: () => dispatch(confirmChangesRejected()),
        onSetSectionSearchValue: (section, value) => dispatch(setSectionSearch(section, value)),
        onSectionSearchChanged: (section, search) => dispatch(sectionSearchInputChanged(section, search)),
        onSectionSortChanged: (section, sortBy, sortDir) => dispatch(sectionSortClicked(section, sortBy, sortDir)),
        onSectionPageChange: (section, nextOffset) => dispatch(refreshSection(section, 'replace', nextOffset)),
        onRefreshSection: section => dispatch(refreshSection(section)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamManagement);
